import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { fetchMe } from "./auth";

export default function RequireAuth({ children }) {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const data = await fetchMe(); // null if 401/403
        if (!alive) return;
        setAuthed(!!data);
      } catch (e) {
        if (!alive) return;
        setAuthed(false);
      } finally {
        if (!alive) return;
        setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  if (loading) return null;
  if (!authed) return <Navigate to="/login" replace state={{ from: location }} />;

  return children;
}


